import { Row, Col } from 'react-bootstrap'
import { CardRowItem } from '../../cardRowItem'
import { IProposalProposalSummarySectionCommissionsProps } from './proposalTypes'

const ProposalSummarySectionCommissions = (
  proposalEstimate: IProposalProposalSummarySectionCommissionsProps
) => {
  const isShortLease = proposalEstimate.leaseTerm < 12

  //Different heading text for Pacific
  let isPAC =
    (proposalEstimate.rpcProvider &&
      proposalEstimate.rpcProvider.toLowerCase() === 'pac') ||
    (proposalEstimate.extendedWarrantyProvider &&
      proposalEstimate.extendedWarrantyProvider.toLowerCase() === 'pac')

  const totalLossAssist = isPAC
    ? 'Total Loss Assist Insurance'
    : 'Total Loss Assist'
  const safeGuardorExtended = isPAC
    ? 'Extended Warranty Insurance'
    : 'Safeguard Ultimate Warranty'
  const rpcText = isPAC
    ? 'Guaranteed Buy Back Insurance'
    : 'Residual Protection Cover'

  //Return a zero value if item undefined, otherwise return item rounded to 2 dp.
  //Can provided two values, which if both are defined & not-null will be added then rounded
  const safeValue = (item: number | undefined, item2?: number | undefined) => {
    if (item == undefined) return 0
    if (!item2) return Math.round(item * 100) / 100
    else return Math.round((item + item2) * 100) / 100
  }

  let procurementFee: number = 0
  let totalCommissionValue: number = 0
  let compMVInsValue: number = 0
  let financierFeeVal: number = 0
  let totalLossAssistVal: number = 0
  let rpcVal: number = 0
  let safeGuardorExtVal: number = 0
  let leaseProtInsVal: number = 0
  let brokerageVal: number = 0

  if (!isShortLease) {
    procurementFee = safeValue(
      proposalEstimate.vehicleProcurementFee &&
        proposalEstimate.vehicleProcurementFee > 0
        ? (proposalEstimate.vehicleProcurementFee /
            proposalEstimate.leaseTerm) *
            12
        : 0
    )

    compMVInsValue = safeValue(
      proposalEstimate.compInsuranceCommissionPerAnnumIncGST
    )
    totalLossAssistVal = safeValue(
      proposalEstimate.gapCoverCommissionPerAnnumIncGST
    )
    rpcVal = safeValue(proposalEstimate.rpcCommissionPerAnnumIncGST)
    safeGuardorExtVal = safeValue(
      proposalEstimate.extendenWarrantyCommissionPerAnnumIncGST
    )
    leaseProtInsVal = safeValue(
      proposalEstimate.leaseProtectionCommissionPerAnnumIncGST
    )
    financierFeeVal = safeValue(
      proposalEstimate.financierEstablishmentFeePerAnnum
    )
    brokerageVal = safeValue(proposalEstimate.brokeragePerAnnum)
  } else {
    //Lease less than 12 months, use total values, not annualised
    procurementFee = safeValue(proposalEstimate.vehicleProcurementFee)

    compMVInsValue = safeValue(
      proposalEstimate.compInsuranceCommissionExGST,
      proposalEstimate.compInsuranceCommGST
    )
    totalLossAssistVal = safeValue(
      proposalEstimate.gapCoverCommissionExGST,
      proposalEstimate.gapCoverCommGST
    )
    rpcVal = safeValue(
      proposalEstimate.rpcCommissionExGST,
      proposalEstimate.rpcCommGST
    )
    safeGuardorExtVal = safeValue(
      proposalEstimate.extendedWarrantyCommExGST,
      proposalEstimate.extendedWarrantyCommGST
    )
    leaseProtInsVal = safeValue(
      proposalEstimate.leaseProtectionCommExGST,
      proposalEstimate.leaseProtectionCommGST
    )
    financierFeeVal = safeValue(proposalEstimate.financierEstablishmentFee)
    brokerageVal = safeValue(proposalEstimate.brokerage)
  }

  totalCommissionValue =
    compMVInsValue +
    totalLossAssistVal +
    rpcVal +
    safeGuardorExtVal +
    leaseProtInsVal +
    financierFeeVal +
    procurementFee +
    brokerageVal

  return (
    <div>
      <div className="font-weight-bold text-uppercase pt-2">
        Oly'S ESTIMATED COMMISSIONS (
        {isShortLease ? 'LEASE TERM' : 'ANNUALISED'})
      </div>
      <CardRowItem
        title="Comprehensive Motor Vehicle Insurance"
        value={compMVInsValue}
        isCurrency="true"
        hideIfNoValue="true"
      />
      <CardRowItem
        title={totalLossAssist}
        value={totalLossAssistVal}
        isCurrency="true"
        hideIfNoValue="true"
      />
      <CardRowItem
        title={rpcText}
        value={rpcVal}
        isCurrency="true"
        hideIfNoValue="true"
      />
      <CardRowItem
        title={safeGuardorExtended}
        value={safeGuardorExtVal}
        isCurrency="true"
        hideIfNoValue="true"
      />
      <CardRowItem
        title="Lease Protection Insurance"
        value={leaseProtInsVal}
        isCurrency="true"
        hideIfNoValue="true"
      />
      <CardRowItem
        title="Finance Establishment fee"
        value={financierFeeVal}
        isCurrency="true"
        hideIfNoValue="true"
      />
      <CardRowItem
        title="Procurement Fee (ex GST)"
        value={procurementFee}
        isCurrency="true"
        hideIfNoValue="true"
      />
      <CardRowItem
        title="Finance brokerage (ex GST)"
        value={brokerageVal}
        isCurrency="true"
        hideIfNoValue="true"
      />

      <Row className="pt-2">
        <Col lg={2} md={0} xs={0}></Col>
        <Col lg={10} md={12} xs={12}>
          <CardRowItem
            title="Total estimated commissions"
            value={totalCommissionValue}
            isCurrency="true"
            rightTextcss="text-right--bold"
          />
          <Row>
            <Col xs={12} className="font-weight-normal subtitle">
              These commissions are inclusive of GST unless stated otherwise.
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default ProposalSummarySectionCommissions
